// extracted by mini-css-extract-plugin
export var cardWrapper = "_5a-0";